import POLICIES from '@/vue-app/router/security/policies';

export default {
  path: '/pending-deposit',
  component: () => import('@/vue-app/views/PendingDeposit.vue'),
  meta: {
    access_policy: POLICIES.AUTHENTICATED,
  },
};
